import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function DoorLeftIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M15.429 4.00007C13.3661 4.00007 10.5487 5.20466 9.16952 6.67664L2.10156 14.2161C1.18135 15.1971 0.751568 17.0334 1.14722 18.2992L3.46019 25.7007C3.85467 26.965 5.30368 28 6.67916 28H28.4999C29.8817 28 31 26.9254 31 25.5999V4L15.429 4.00007ZM4.91667 14.7997L11.0272 8.28222C11.9355 7.31416 14.0741 6.39982 15.429 6.39982H28.4999V14.7997H4.91667ZM28.4999 19.5999H23.5001V17.1998H28.4999V19.5999Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
